import React from "react";
import {useMutation, useSubscription} from "@apollo/client";
import {QUERY_SERVICE, QUERY_SERVICE_ARCHIVED} from "../registryComponentsGQL.js";
import {Box} from "grommet";
import {DataGrid} from "@mui/x-data-grid";
import {Button as ButtonMui} from "@mui/material";
import {DELETE_SERVICE, UNARCHIVE_SERVICE} from "./ServiceGQL.js";

function Servizi(props){
    const [deleteService] = useMutation(DELETE_SERVICE);
    const [unarchiveService] = useMutation(UNARCHIVE_SERVICE);
    
    const { data: dataActive, loading: loadingActive } = useSubscription(
      QUERY_SERVICE,
    );
    
    const { data: dataArchived, loading: loadingArchived } = useSubscription(
      QUERY_SERVICE_ARCHIVED,
    );

    // Combina i servizi attivi e archiviati
    const combinedData = React.useMemo(() => {
      const activeServices = dataActive?.["clubmate_clubmateservice_clubmateservice"] || [];
      const archivedServices = dataArchived?.["clubmate_clubmateservice_clubmateservice"] || [];
      return [...activeServices, ...archivedServices];
    }, [dataActive, dataArchived]);

    const columnsPack = [
      { field: 'name', headerName: 'Nome', width: 170 },
      { field: 'price', headerName: 'Prezzo', width: 170 },
      { field: 'visible_for_partner', headerName: 'Partner', width: 170 },
      { field: 'entrance_service', headerName: 'Servizio di ingresso per non soci?', width: 250 },
      { field: 'request_entrance_for_use', headerName: "Richiede l'ingresso per essere utilizzato?", width: 300 },
      {
        field: 'actions',
        headerName: 'Azioni',
        width: 120,
        renderCell: (cellValues) => {
          // Se il servizio è archiviato, mostra il bottone Disarchivia
          if (cellValues.row.archive) {
            return (
              <ButtonMui
                variant="contained"
                color="success"
                onClick={(event) => {
                  let res = window.confirm("Sei sicuro di voler disarchiviare il servizio?");
                  if (res) {
                    unarchiveService({variables: { id: cellValues.row.id }});
                  }
                }}
              >
                Disarchivia
              </ButtonMui>
            );
          } else {
            // Se il servizio è attivo, mostra il bottone Modifica
            return (
              <ButtonMui
                variant="contained"
                color="warning"
                onClick={(event) => {
                  props?.setElementSel(cellValues.row)
                }}
              >
                Modifica
              </ButtonMui>
            );
          }
        },
      },
      {
        field: 'delete',
        headerName: 'Cancella',
        width: 120,
        renderCell: (cellValues) => {
          return (
            <ButtonMui
              variant="contained"
              color="error"
              onClick={(event) => {
                let res = window.confirm("Sei sicuro di voler eliminare il servizio?");
                if (res) {
                  deleteService({variables: { id: cellValues.row.id }})
                }
              }}
            >
              Cancella
            </ButtonMui>
          );
        },
      }
    ];

    return (
      <Box overflow="auto" height="100%" width="100%" alignSelf='center' style={{marginTop:'40px'}}>
        <div style={{ height: '72vh', width: '100%' }}>
          <DataGrid
            rows={combinedData}
            columns={columnsPack}
            getRowClassName={(params) => {
              // Applica la classe CSS per i servizi archiviati
              return params.row.archive ? 'archived-row' : '';
            }}
            sx={{
              '& .archived-row': {
                backgroundColor: '#ffebee', // Rosso chiaro
                '&:hover': {
                  backgroundColor: '#ffcdd2', // Rosso leggermente più scuro al hover
                },
              },
            }}
          />
        </div>
      </Box>
    )
}

export default Servizi;